export default defineNuxtRouteMiddleware((to) => {
  const queryToPersist = [
    "utm_source",
    "onelink_template_id",
    "onelink_url_id",
    "referrerId",
    "dplcode",
  ]; // 유지할 쿼리 키 지정

  if (process.server) return;

  // 현재 URL의 쿼리에서 유지할 값만 필터링
  const filteredQuery = Object.fromEntries(
    Object.entries(to.query).filter(([key]) => queryToPersist.includes(key)),
  );

  // 새로운 값이 있으면 sessionStorage에 저장
  if (Object.keys(filteredQuery).length > 0) {
    sessionStorage.setItem("persistent-query", JSON.stringify(filteredQuery));
  }

  // 쿼리가 없고, 기존 저장된 값이 있다면 복원
  if (Object.keys(to.query).length === 0) {
    const savedQuery = sessionStorage.getItem("persistent-query");
    if (savedQuery) {
      return navigateTo(
        { path: to.path, query: JSON.parse(savedQuery) },
        { replace: true },
      );
    }
  }
});
